import type { JSX } from 'react'

export const ExternalContentIcon = (): JSX.Element => (
  <use href='#externalContentIcon' height='100%' width='100%' />
)
